import { render, staticRenderFns } from "./EditThirdpartnarModalId.vue?vue&type=template&id=0c359b79&scoped=true"
import script from "./EditThirdpartnarModalId.vue?vue&type=script&lang=ts"
export * from "./EditThirdpartnarModalId.vue?vue&type=script&lang=ts"
import style0 from "./EditThirdpartnarModalId.vue?vue&type=style&index=0&id=0c359b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c359b79",
  null
  
)

export default component.exports